import { Component, forwardRef, Input, OnDestroy, ViewChild } from '@angular/core';
import { AbstractControl, ControlValueAccessor, FormsModule, NG_VALIDATORS, NG_VALUE_ACCESSOR, NgForm, Validator } from '@angular/forms';
import { Subscription } from 'rxjs';
import { PolGemeindeComponent } from '../pol-gemeinde/pol-gemeinde.component';
import { GeometergeschaeftNummerSearchRequestMeta } from '../../../core/av-api';
import { PolitischeGemeindeSearchmode } from '../pol-gemeinde/politische-gemeinde-searchmode';
import { CapFormRowDirective } from '../../form-control/cap-form-row.directive';
import { CapFormControlComponent } from '../../form-control/form-control.component';
import { MetaDisablerDirective } from '../../directives/meta-disabler.directive';
import { MetaValidatorDirective } from '../../directives/meta-validator.directive';

@Component({
  selector: 'cap-geometergeschaeft-nummer',
  templateUrl: './geometergeschaeft-nummer.component.html',
  styleUrls: ['./geometergeschaeft-nummer.component.scss'],
  providers: [
    { provide: NG_VALIDATORS, useExisting: forwardRef(() => GeometergeschaeftNummerComponent), multi: true },
    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => GeometergeschaeftNummerComponent), multi: true }
  ],
  imports: [FormsModule, CapFormRowDirective, CapFormControlComponent, PolGemeindeComponent, MetaDisablerDirective, MetaValidatorDirective]
})
export class GeometergeschaeftNummerComponent implements OnDestroy, ControlValueAccessor, Validator {
  @Input()
  searchMode: PolitischeGemeindeSearchmode;

  @ViewChild(NgForm, { static: false })
  form: NgForm;

  @Input() name: string;
  @Input() heading: string;
  @Input() nurGueltige = true;
  @Input() hasfocus = false;
  model: GeometergeschaeftNummerSearchRequestMeta | undefined;
  onTouched: () => void;
  onValidatorChange: () => void;
  @ViewChild(PolGemeindeComponent, { static: false })
  private gemeindeComponent: PolGemeindeComponent;
  private _subscription: Subscription;

  registerOnValidatorChange?(fn: () => void): void {
    this.onValidatorChange = fn;
  }

  writeValue(obj: any): void {
    this.model = obj;
  }

  registerOnChange(fn: any): void {
    this._subscription = this.form.control.valueChanges.subscribe(() => {
      // we can't pass the inner form's model because that model is derived from the form model
      // which does not know about, and therefore copy, properties not mapped with ngModel, such as our metas
      // to preserve the metas, we therefore pass our original model. Hopefully this never causes a problem ... (MOO)
      fn(this.model);
    });
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
    // TODO das formular fragen, wann der Event auftritt, damit wir nicht unser Template verunstalten muessen
  }

  focus() {
    this.hasfocus = true;
  }

  validate(c: AbstractControl): {
    [key: string]: any;
  } | null {
    return this.form.valid ? null : { nestedErrors: true };
    // we can't return {} to signal nested errors in a semantically appropriate way
    // because mergeErrors helpfully ignores objects without keys :-(
  }

  ngOnDestroy(): void {
    this._subscription?.unsubscribe();
  }

  emptyGemeindeSearch() {
    this.gemeindeComponent.onClear();
    this.model.polGemeindeId = null;
  }
}
